import React, { useContext, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'

import ModalContext from '../../../State/Modal/Context'
import JobsitesContext from '../../../State/Jobs/Context'
import NotificationsContext from '../../../State/Notifications/Context'

import useTranslate from '../../../Utils/Hooks/useTranslate'
import useErrorNotifier from '../../../Utils/Hooks/useErrorNotifier'
import useAsyncCallback from '../../../Utils/Hooks/useAsyncCallback'

import ModalContent from '../../Modal/Components/ModalContent'
import ModalFooter from '../../Modal/Components/ModalFooter'
import SubmitButton from '../../Modal/Components/SubmitButton'
import Button from '../../Button'
import { StyledDiv } from './Styles'


const JobsArchive = () => {
  const { actions: { closeModal, setSubmitted } } = useContext(ModalContext)
  const { actions: { toggleJobsiteStatus }, selectors: { getSelectedJobsitesList } } = useContext(JobsitesContext)
  const { actions: { addNotification } } = useContext(NotificationsContext)
  const translate = useTranslate('archiveJobsitesModal')
  const selectedJobs = getSelectedJobsitesList()
  const [execute, , , result, hasError] = useAsyncCallback(toggleJobsiteStatus)
  useErrorNotifier(hasError, result)
  const handleClick = () => {
    closeModal()
  }

  const labels = {
    submittingLabel: translate('labels.deactivating'),
    buttonLabel: translate('labels.deactivate')
  }

  const handleArchiving = async () => {
    await execute(selectedJobs)
    closeModal()
    setSubmitted()
  }

  useEffect(() => {
    if (hasError === false) {
      addNotification(translate('notifications.success'), 'success', 2)
    }
  }, [hasError]) // eslint-disable-line

  return (
    <>
      <ModalContent>
        <StyledDiv>
          {translate('copy')}
        </StyledDiv>
        <ReactMarkdown>{translate('copyFooter')}</ReactMarkdown>
      </ModalContent>
      <ModalFooter>
        <Button inverted onClick={handleClick}>{translate('labels.cancel')}</Button>
        <SubmitButton labels={labels} onClick={handleArchiving} />
      </ModalFooter>
    </>
  )
}

export default JobsArchive
